export default "__VITE_ASSET__DWXJgk4F__"